import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";

import arrowLeft from "../../../../assets/img/components/arrow-left.webp";
import arrowRight from "../../../../assets/img/components/arrow-right.webp";
import img1 from "../../../assets/img/landingPageTwo/sectionThree/pagar.png";
import img2 from "../../../assets/img/landingPageTwo/sectionThree/bonus.png";
import img3 from "../../../assets/img/landingPageTwo/sectionThree/saude.png";
import img4 from "../../../assets/img/landingPageTwo/sectionThree/treinamento.png";
import img5 from "../../../assets/img/landingPageTwo/sectionThree/uniforme.png";
import img6 from "../../../assets/img/landingPageTwo/sectionThree/desconto.png";
import img7 from "../../../assets/img/landingPageTwo/sectionThree/dente.png";
import img8 from "../../../assets/img/landingPageTwo/sectionThree/familia.png";
import img9 from "../../../assets/img/landingPageTwo/sectionThree/descanso.png";
import img10 from "../../../assets/img/landingPageTwo/sectionThree/parceria.png";
import arrow from "../../../../assets/img/components/buttonBlue.webp"

const BENEFITS = [
  { key: "lp2_benefit1", img: img1 },
  { key: "lp1_benefit2", img: img2 },
  { key: "lp1_benefit3", img: img3 },
  { key: "lp1_benefit4", img: img4 },
  /* { key: "lp1_benefit5", img: img5 }, */
  { key: "lp1_benefit6", img: img6 },
  { key: "lp1_benefit7", img: img7 },
  { key: "lp1_benefit8", img: img8 },
  { key: "lp2_benefit9", img: img9 },
  { key: "lp2_benefit10", img: img5 },
  { key: "lp2_benefit11", img: img10 },
];

function SectionThree() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  const breakpoints = {
    1200: {
      slidesPerView: 4,
    },
    1000: {
      spaceBetween: 20,
    },
    900: {
      slidesPerView: 3,
    },
    700: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
      <div id="benefits" className={`sectionThree ${isVisible ? "visible" : ""}`}>
        <img className={`arrow1 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
        <img className={`arrow2 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
        <div className="sectionThreeTitle">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp1_benefits_title")}
          </h1>
          <p className={`${isVisible ? "visible" : ""}`}>
            {t("lp1_benefits_subtitle")}
          </p>
        </div>
        <Swiper
          slidesPerView={4}
          spaceBetween={40}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          speed={500}
          loop={true}
          modules={[Autoplay, Navigation]}
          breakpoints={breakpoints}
          className={`${isVisible ? "visible" : ""}`}
        >
          <div className={`swiper-button-prev`}>
            <img src={arrowLeft} width={"40px"} alt="" />
          </div>
          {BENEFITS.map((benefit) => (
            <SwiperSlide key={benefit.key}>
              <div className={`card1 card ${isVisible ? "visible" : ""}`}>
                <img src={benefit.img} alt="" />
                <p>{t(benefit.key)}</p>
              </div>
            </SwiperSlide>
          ))}
          <div className={`swiper-button-next`}>
            <img src={arrowRight} width={"40px"} alt="" />
          </div>
        </Swiper>
      </div>
    </VisibilitySensor>
  );
}

export default SectionThree;
